import React from "react";
import { Button, useDisclosure } from "@chakra-ui/react";
import { IoAdd } from "react-icons/io5";
import { Modal } from "components";
import Form from "../form";
import { DEFAULT_VALUES, useCreateMedication } from "./duck";

const Create: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const onSubmit = useCreateMedication(onClose);

  return (
    <>
      <Button leftIcon={<IoAdd />} onClick={onOpen}>
        Add
      </Button>
      {isOpen && (
        <Modal isOpen={isOpen} onClose={onClose} title="Medication" size="lg">
          <Form
            defaultValues={DEFAULT_VALUES}
            onSubmit={onSubmit}
            onCancel={onClose}
          />
        </Modal>
      )}
    </>
  );
};

export default Create;
